import React, { FC } from 'react';
import Footer from './components/footer';
import Header from './components/header';
import RegionSelector from './components/regionSelector';
import { SplashComponentModel } from './models/splashComponent.model';
import { TSplashComponentProps } from './types/splashComponent.types';

const SplashComponent: FC<TSplashComponentProps> = (props) => {
  const model = new SplashComponentModel(props);

  return (
    <div className="splash-component">
      <Header model={model} />
      <RegionSelector model={model} />
      <Footer model={model} />
    </div>
  )
};

export default SplashComponent;